<!-- 热门课程榜单列表-->
<template>
  <div
    :class="['hotSale-index', { inApp: $root.$data.isApp || $root.miniprogram }, 'acvitity_foot_left_group']"
  >
    <common-title :isAPPShow="true" titleName="一对一课程" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <template v-if="!listEmpty">
      <!-- <HotSaleSwiper
        v-if="hotList.length"
        :hotList="hotList"
      />-->

      <!-- <div :class="['course_classify_box', { course_classify_box_inApp: $root.$data.isApp || $root.miniprogram }]">
        <div :class="['course_classify_item', activeKey === item[0] ? 'course_classify_item_active' : '']"
          v-for="item in classifyList" :key="item[0]" @click="onChangeClassify(item)">{{ item[0] }}</div>
      </div>-->

      <div class="course_list">
        <div class="course_item" v-for="(item, index) in courseInfoData" :key="item.productId">
          <div class="knowledge_course_box">
            <img class="knowledge_course_img" :src="item.coverMobile" alt />
            <div class="knowledge_course_name">{{ item.name }}</div>
            <div class="knowledge_course_num">
              {{ Number(item.realSales || 0) + Number(item.initialSales || 0)
              }}人已购买
            </div>
            <div class="knowledge_course_price">
              <!-- 划线价 -->
              <!-- <del
                v-if="(item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) || item.promotionLabel"
              class="course_line_price">￥{{ item.originalPrice }}</del>-->

              <div class="course_price_box">
                <!-- 拼团价 -->
                <div
                  class="course_price_tip"
                  v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >拼团价</div>

                <!-- 促销价 -->
                <div class="course_price_tip" v-else-if="item.promotionLabel">
                  {{ item.promotionLabel === 1 ?
                  '折后价' :
                  item.promotionLabel === 4 ? '券后价' : '限时价' }}
                </div>

                <!-- 价格icon -->
                <div
                  class="course_price_icon"
                  v-if="(item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) || !(item.sellPrice === 0 && !item.promotionLabel)"
                >￥</div>

                <!-- 价格 -->
                <div
                  class="course_price_num"
                  v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >{{ item.productDiscountRespVO.discountMinPrice }}</div>

                <!-- 免费 -->
                <div class="course_price_free" v-else>
                  {{
                  item.sellPrice === 0 && !item.promotionLabel ? '' : item.sellPrice
                  }}
                </div>
              </div>
            </div>
            <div class="knowledge_course_btn" @click="goDateil(item)">立即咨询</div>
          </div>
        </div>
      </div>

      <!-- <div class="course-list">
        <h3 class="hotListTitle">课程榜单</h3>
        <div v-for="(item, keys) in courseInfoData" :key="keys" @click="goback()">
          <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
          <HotCourseCard v-else :key="keys" :item="item" />
        </div>
      </div>-->
    </template>
    <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    <Foot />
    <van-popup v-model="showPop" position="bottom" :get-container="getContainer">
      <div class="close-btn" @click="showPop = false">
        <van-icon name="cross" />
      </div>
      <component
        v-if="showPop"
        :is="communityType | typeToComponentName"
        :communityInfo="communityInfo"
      />
    </van-popup>
  </div>
</template>

<script>
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts, reqHotEvaluation } from '@/api/home';
import { reqCourseDetailStreamline } from '@/api/courseDetail/index';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import HotSaleSwiper from './components/hotSaleSwiper';
import TagComponent from '@/components/commonComponents/TagComponent.vue';
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';

import qqPopupComponent from '@/components/courseDetail/footCommuntiy/qqPopupComponent.vue';
import wxPopupComponent from '@/components/courseDetail/footCommuntiy/wxPopupComponent.vue';

export default {
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === '1-1' || val === '1-2') {
        componentName = 'qqPopupComponent';
      } else if (val === '2-1' || val === '2-2' || val === 'wxAccount') {
        componentName = 'wxPopupComponent';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      showPop: false,
      communityType: '', // 社群按钮类型
      communityInfo: {}, // 社群详情信息
      courseInfoData: [],
      ids: [],
      listEmpty: false,
      hotList: [],
      activeKey: '全部',
      classifyList: new Map([]),
    };
  },

  components: {
    HotCourseCard,
    CombinationCard,
    EmptyData,
    Foot,
    HotSaleSwiper,
    TagComponent,
    qqPopupComponent,
    wxPopupComponent,
  },

  computed: {},
  created() {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
  },
  mounted() {
    this.getProductEvaluation();
    this.getCourseAd();
    // if (this.$root.$data.isApp) {
    //   this.getCourseAd();
    // } else {
    //   const list = sessionStorage.getItem('HOTSALELIST');
    //   this.courseInfoData = JSON.parse(list);
    //   if (!this.courseInfoData.length) {
    //     this.listEmpty = true;
    //   }
    // }
  },
  destroyed() {},
  methods: {
    goDateil(item) {
      reqCourseDetailStreamline(item.productId).then(res => {
        console.log(res, 'detail');
        gio('track', 'CourseConsultation_ever', {
          courseld_var: item.productId,
          courseName_var: item.name,
          courseCate_var: res.data.productCategoryName,
          courseSubject_var: item.productCategoryName,
          enter_var: this.$route.query.recommendName,
        });
      });

      this.goback();
      console.log(item, 'val');
      const { productId, productSkuSimpleVOS } = item;
      const { productSkuId } = productSkuSimpleVOS?.[0] || {};
      reqCourseCommunitySku(productId, productSkuId).then(request => {
        if (request.data && request.data?.productId) {
          this.communityInfo = request.data;
          if (request.code === 0 && request.data) {
            const { data } = request;
            this.communityType = `${data.platform}-${data.accountType}`;
          } else {
            this.communityType = 'wxAccount';
          }
          this.showPop = true;
        } else {
          console.log(item, 'item');
          if (item.setType === 1) {
            this.enterDetailsPack(item);
          } else {
            this.enterDetailsProd(item);
          }
          // sessionStorage.setItem('back', true);
          // this.$router.push({
          //   path: '/courseDetail',
          //   query: {
          //     courseId: productId,
          //   },
          // });
        }
      });
    },
    getContainer() {
      return document.querySelector('.acvitity_foot_left_group');
    },
    tagType(val) {
      const type = [];
      if (val.isUnionDiscount) {
        type.push('联报优惠');
      }
      if (val.isSingleDiscount) {
        type.push('单减活动');
      }
      if (val.isCouponDiscount) {
        type.push('优惠券');
      }
      if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
        type.push('满减活动');
      }
      // 增加购课增好礼标签
      if (val.productDiscountRespVO && val.productDiscountRespVO.isBuyGiftGiveawaysDiscount) {
        type.push('购课赠好礼');
      }
      // 整改暂时注释分期
      /* if (val.huabeiStagingActivity) {
          type.push(`${val.huabeiStagingActivity.maxNumberOfPeriod}期分期免息`);
        } */
      if (val?.isEbook) {
        type.push('电子书');
      }
      if (val?.setType == 1) {
        type.push('套餐');
      }
      return type;
    },
    onChangeClassify(item) {
      console.log(item);
      this.activeKey = item[0];
      this.courseInfoData = this.classifyList.get(item[0]);
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取热销产品评价轮播
    async getProductEvaluation() {
      const res = await reqHotEvaluation();
      this.hotList = res?.data?.data;
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.$route.query.recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.listEmpty = true;
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach(child => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then(result => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        const courseClassifyMap = new Map();
        courseClassifyMap.set('全部', []);

        recommendContentVOList.forEach(child => {
          const findRes = [...resCourse, ...resPackage].find(course => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          if (findRes) {
            const { productCategoryName, categoryName } = findRes;
            const cateName = child.recommendType === 0 ? productCategoryName : categoryName;
            if (cateName) {
              let classify = courseClassifyMap.get(cateName);
              if (classify) {
                classify.push(findRes);
              } else {
                courseClassifyMap.set(cateName, [findRes]);
              }
            }
          }
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        let ls = courseClassifyMap.get('全部');
        ls.push(...allCourse);
        this.classifyList = courseClassifyMap;
        this.courseInfoData = allCourse;
      });
    },

    // 产品进入详情
    enterDetailsProd(courseInfo) {
      const { productSkipConfigRespVO, productId } = courseInfo;
      const { query } = this.$route;
      // 判断是否App
      if (this.$root.$data.isApp) {
        if (productSkipConfigRespVO?.source === 1 && productSkipConfigRespVO?.skipType === 0) {
          // 外部产品
          this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else if (
          // 淘宝产品
          productSkipConfigRespVO?.source === 1 &&
          productSkipConfigRespVO?.skipType === 1
        ) {
          this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else {
          this.$sendToApp('goCourseDetail', Number(productId), false);
        }
        return;
      }
      if (productSkipConfigRespVO?.source === 1) {
        // 外部产品
        window.open(productSkipConfigRespVO?.mobileSkipUrl);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        // 直播间内的推荐课程
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            liveRoomId: roomId,
            beforePageName: 6,
          },
        });
        // window.open(`${window.location.origin}/ark/courseDetail?courseId=${productId}&liveRoomId=${roomId}&beforePageName=6`)
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            beforePageName: 6,
            ...query,
          },
        });
      }
    },

    // 套餐进入详情
    enterDetailsPack(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToCombinationCourse', Number(courseInfo.packageId), false);
        return;
      }
      const { roomId } = this.$route.query;
      const { query } = this.$route;
      if (roomId) {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            liveRoomId: roomId,
          },
        });
      } else {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            ...query,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  top: 67px;
  right: 29px;
  z-index: 999;
  display: flex;
  color: #a8a8a8;

  i {
    font-size: 40px;
  }
}
::-webkit-scrollbar {
  height: 0;
}

.knowledge_course_box {
  width: 678px;
  height: 181px;
  background: #ffffff;
  border-radius: 14rpx;
  position: relative;

  .knowledge_course_img {
    float: left;
    width: 188px;
    height: 136px;
    margin-top: 24px;
    margin-left: 22px;
  }

  .knowledge_course_name {
    float: left;
    width: 366px;
    height: 33px;
    font-weight: 500;
    font-size: 25px;
    color: #333333;
    line-height: 33px;
    margin-top: 25px;
    margin-left: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .knowledge_course_num {
    float: left;
    height: 25px;
    width: 300px;
    text-align: left;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
    line-height: 25px;
    margin-top: 7px;
    margin-left: 14px;
  }

  .knowledge_course_price {
    float: left;
    margin-top: 18px;
    margin-left: 14px;
    width: 300px;
    display: flex;

    .course_line_price {
      height: 31px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #999999;
      line-height: 31px;
    }

    .course_price_box {
      display: flex;
      align-items: center;
      justify-content: center;

      .course_price_tip {
        width: 65px;
        height: 29px;
        background: #ff3938;
        border-radius: 5px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        line-height: 29px;
        text-align: center;
      }

      .course_price_icon {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #ff3938;
        line-height: 56px;
      }

      .course_price_num {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #ff3938;
        line-height: 45px;
      }

      .course_price_free {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #ff3938;
        line-height: 45px;
      }
    }

    .knowledge_price_active {
      width: 65px;
      height: 29px;
      background: #ff3938;
      border-radius: 5px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      line-height: 29px;
      text-align: center;
      margin-top: 14px;
    }

    .knowledge_price_value {
      height: 51px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 25px;
      color: #ff3938;
      line-height: 51px;
    }
  }

  .knowledge_course_btn {
    position: absolute;
    width: 125px;
    height: 42px;
    background: #ff7f41;
    border-radius: 21px;
    bottom: 22px;
    right: 22px;

    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
}

.hotSale-index {
  width: 100%;
  min-height: 100vh;
  padding-top: 100px;
  font-family: PingFangSC, PingFang SC;
  background: #f7f8fc;

  &.inApp {
    padding-top: 95px;
  }

  .course-list {
    padding: 40px;

    .hotListTitle {
      margin-bottom: 32px;
      color: #111;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
    }
  }

  .course_classify_box {
    position: fixed;
    left: 0;
    top: 100px;
    height: 91px;
    width: 100%;
    display: flex;
    gap: 45px;
    background: #ffffff;
    padding: 0 36px;
    z-index: 6;
    overflow-x: auto;

    .course_classify_item {
      flex-shrink: 0;
      height: 91px;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 91px;
    }

    .course_classify_item_active {
      color: #ff7f41;
    }

    .course_classify_item_active::after {
      content: '';
      position: relative;
      display: block;
      width: 29px;
      height: 7px;
      bottom: 7px;
      left: 50%;
      transform: translateX(-50%);
      background: #ff7f41;
    }
  }

  .course_classify_box_inApp {
    top: 0;
  }

  .course_list {
    padding: 29px 36px 0;
    min-height: 100vh;

    .course_item {
      width: 678px;
      height: 181px;
      background: #ffffff;
      border-radius: 14px;
      border: 1px solid #f1d8b8;
      margin-bottom: 22px;
      overflow: hidden;

      .course_content {
        height: 173px;
        width: 100%;
        overflow: hidden;

        .course_img_box {
          float: left;
          position: relative;
          height: 136px;
          width: 188px;
          margin-top: 20px;
          margin-left: 18px;

          .course_img_cover {
            height: 100%;
            width: 100%;
            border-radius: 11px;
          }

          .course_img_icon {
            position: absolute;
            height: 29px;
            width: 94px;
            top: 0;
            right: 0;
          }
        }

        .course_info {
          float: left;
          width: 438px;
          margin-top: 29px;
          margin-left: 14px;

          .course_title {
            height: 33px;
            width: 438px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #333333;
            line-height: 33px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .course_tags {
            margin-top: 11px;
            height: 29px;
            display: flex;
            gap: 7px;

            .course_tag {
              // width: 69px;
              height: 29px;
              padding: 0 7px 0;
              background: #ff7f41;
              border-radius: 5px;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              line-height: 29px;
            }
          }

          .course_time {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            line-height: 25px;
            margin-top: 25px;
          }
        }
      }

      .course_bottom {
        position: relative;
        height: 64px;
        width: 100%;
        background: #fff9e9;
        border-radius: 0px 0px 14px 14px;
        border: 1px solid #f1d8b8;
        display: flex;
        align-items: center;

        .course_bottom_icon {
          display: block;
          height: 29px;
          width: 29px;
          margin-left: 18px;
        }

        .course_bottom_num {
          height: 31px;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
          line-height: 31px;
          margin-left: 7px;
        }

        .course_line_price {
          position: absolute;
          top: 18px;
          right: 249px;
          height: 31px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
          line-height: 31px;
        }

        .course_price_box {
          position: absolute;
          top: 0;
          right: 0;
          height: 65px;
          width: 243px;
          background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_price_bkg.png')
            no-repeat;
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;

          .course_price_tip {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            line-height: 33px;
          }

          .course_price_icon {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #ffffff;
            line-height: 33px;
          }

          .course_price_num {
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 36px;
            color: #ffffff;
            line-height: 51px;
          }

          .course_price_free {
            height: 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 29px;
            color: #ffffff;
            line-height: 40px;
          }
        }
      }
    }
  }
}

::v-deep .topType {
  display: none;
}

::v-deep .common-foot {
  position: relative;
}
</style>
